module.exports = __webpack_public_path__ + "img/camera-video-off-fill.53a6ea63.svg";